import React from "react";

export interface TopbarProps {}

export const Topbar: React.FC<TopbarProps> = ({ children }) => {
  return <div className="topbar">{children}</div>;
};
